import Box from '@mui/material/Box'
import { FunctionComponent, useState } from 'react'
import CategoryLayout from 'components/Layout/Category'
import useEmotionStyles from 'hooks/useEmotionStyles'

interface WrapperProps {
  children: React.ReactElement
  validator: (value: string) => boolean
  value: string
  disableDisclose?: boolean
  testId?: string
}

const styles = () => ({
  undisclosedBox: {
    display: 'none'
  }
})

const Wrapper: FunctionComponent<WrapperProps> = ({
  children,
  validator,
  value,
  disableDisclose,
  testId
}) => {
  const [isPathCompleted, setIsPathCompleted] = useState(false)
  const { undisclosedBox } = useEmotionStyles(styles)

  /* rendering a component progressively caused re-rendering due to wrappers that we have 
  to solve this we will render the components but hide them */

  /* to maintain nesting of text elements we return children directly for caption elements */
  const returnedElement =
    children.props.variant === 'caption' ? (
      children
    ) : (
      <Box data-testid={testId}>
        <CategoryLayout>{children}</CategoryLayout>
      </Box>
    )

  if (isPathCompleted || disableDisclose) {
    return returnedElement
  }

  if (validator(value)) {
    setIsPathCompleted(true)
    return returnedElement
  }

  return (
    <Box className={undisclosedBox} data-testid={testId}>
      <CategoryLayout>{children}</CategoryLayout>
    </Box>
  )
}

export default Wrapper
